import {Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
  },
  carousel: {
    position:'fixed',
    '& .carousel.carousel-slider': {
      [theme.breakpoints.down('sm')]: {
        height: '60%',
      },
      [theme.breakpoints.down('md')]: {
        height: '60%',
      }
    }
  },
  carouselContent: {
    position: 'absolute',
    top: '20%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      transform: 'translate(-50%, -50%)',
    }
  },
  subHeadline: {
    fontSize: '2rem',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem'
    }
  },
  headline: {
    color: '#fff',
    fontSize: '4rem',
    fontWeight: 'bold',
    textShadow: `-1px -1px 0 ${theme.palette.common.black}, 1px -1px 0 ${theme.palette.common.black}, -1px 1px 0 ${theme.palette.common.black}, 1px 1px 0 ${theme.palette.common.black}`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem'
    }
  }
}));

function Banner(props) {
  const classes = useStyles();
  return <>
    <Carousel className={classes.carousel} showStatus={false} infiniteLoop={true}
                                                 autoPlay={true} interval={10000}
                                                 showThumbs={false}>
    {props.pageDetails.map((details, index) => <div key={index}>
      <img src={details.image} />
      <div className={classes.carouselContent}>
        <Typography variant='h1' className={classes.headline}>{details.headline}</Typography>
        <Typography variant='subtitle2' className={classes.subHeadline}>{details.subHeadline}</Typography>
      </div>
    </div>)}
  </Carousel>
  </>;
}

export default Banner;
